import React, { Component } from 'react';
import { Layout } from 'antd';
import { defineMessages ,   injectIntl } from 'react-intl';
import GuideNav from '../../components/navigation/GuideNav';
import GuideCaution from '../../components/GuideCaution';
import FrequentMistakes from '../../components/FrequentMistakes';
import SizeAndMargins from '../../components/SizeAndMargins';
import Headline from '../../components/Headline';
import GuideBoxUI from '../../components/GuideBoxUI';

const { Content } = Layout;

const messages=defineMessages({
  format:{
    id:'Guide.formatTable.format',
    defaultMessage:'Format'
  },
  background:{
    id:'Guide.formatTable.background',
    defaultMessage:'Background'
  },
  backgroundData:{
    id:'Guide.formatTable.background.data',
    defaultMessage:'Transparent'
  },
  resolution:{
    id:'Guide.formatTable.resolution',
    defaultMessage:'Resolution'
  },
  colorMode:{
    id:'Guide.formatTable.colorMode',
    defaultMessage:'Color Mode'
  },
  colorModeData:{
    id:'Guide.formatTable.colorMode.data',
    defaultMessage:'RGB (Recommend)'
  }
});
class StillImageSticker extends Component{

  render(){
    const {formatMessage}=this.props.intl;
    const formatColumn = [{
        title: formatMessage(messages.format),
        dataIndex:'format'
      },{
        title: formatMessage(messages.background),
        dataIndex:'background'
      },{
        title: formatMessage(messages.resolution),
        dataIndex:'resolution'
      },{
        title: formatMessage(messages.colorMode),
        dataIndex:'colorMode'
    }];
    const formatData =  [{
      key: '1',
      format: 'PNG',
      background: formatMessage(messages.backgroundData),
      resolution: '72 dpi',
      colorMode:formatMessage(messages.colorModeData)
    }];

    return(
      <Layout style={{background: '#fff' }}>
        <GuideNav selectedKey={"stillImageSticker"} openKey={"movingStatus"} />
        <Content style={{margin:20}}>
          <Headline id="Guide.stillImageSticker.headline" defaultMessage="Still Image Sticker"
            styles={{margin: '22px 0px 0px 0px', fontFamily: 'NotoSans', fontSize: '34px', lineHeight: '36px', letterSpacing: 0}}
          />
          <div className="guide-wrapper">
            <GuideCaution/>
            <GuideBoxUI
              imgIcon={require('../../img/guide/format_icon_png.svg').default}
              title={{
                id: 'Guide.format',
                defaultMessage :'Format'
              }}
              table={{
                column : formatColumn,
                data: formatData
              }}
              description={{
                id :'Guide.stillImageSticker.format.description',
                defaultMessage:'- Save your stickers in the PNG file format. (transparent Background)<br/><br/>- If the entire background is filled with colors or filled with patterns and <br/>&nbsp;&nbsp;&nbsp;you do not have an empty background image, <br/>&nbsp;&nbsp;&nbsp;you can submit it by matching the image size and format.'
              }}
            />
            <SizeAndMargins/>
            <FrequentMistakes/>
          </div>
        </Content>
      </Layout>
    )
  }

}
  
StillImageSticker=injectIntl(StillImageSticker);

export default StillImageSticker;
